<template>
  <div class="shop-products-single is-medium-wide">
    <ShopProductCard
      v-if="product"
      :key="product.id"
      :item="product"
    />

    <div
      v-if="buttonText"
      class="shop-products-single__button"
    >
      <AtomButton
        :text="buttonText"
        @click="addProduct()"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
    buttonText: {
        type: String,
        default: '',
    },
});

const product = computed(() => props?.product?.product);

const cartStore = useCartStore();
const addProduct = async () => {
    if (!product.value) return;
    cartStore.addProduct(product.value, {
        openPopup: false,
        isAdd: true,
    });

    await navigateTo('/warenkorb');
};

provide('is-popup-disabled', {
    value: false,
});
</script>

<style lang="scss" scoped>
.shop-products-single {
    @include default-content-columns();
    @include fluid('margin-bottom', 20px, 47px);
}

.shop-products-single__button {
    @include fluid('margin-top', 25px, 47px);

    display: flex;
    justify-content: center;
}
</style>
